<template>
  <div class="page">
    <!-- 搜索框 -->
    <div class="group_1">
      <div class="search">
        <img src="../assets/new/Frame@2x.png" alt="" />
        <input type="text" placeholder="搜索您想要的关键词" class="search-input" @click="handleToSelect" />
      </div>
      <!-- 分类 -->
      <div class="classification" v-if="showOpen">
        <div class="section_5">
          <span class="text_5">分类</span>
          <div>
            <!-- <span
                :class="{ 'active-tag': activeCategory === '全部' }"
                class="text_6"
                @click="selectCategory(all)"
                >全部</span
              > -->
          </div>

          <div class="box_2" style="overflow-y: scroll; white-space: nowrap" ref="scrollContainer">
            <div
              v-for="(item, index) in categories.professional"
              :key="index"
              class="text_6"
              :ref="el => setItemRef(el, item.codeNo)"
              :class="{ 'active-tag': activeCategory === item.codeName }"
              @click="selectCategory(item)"
            >
              {{ item.codeName }}
            </div>
          </div>
        </div>
        <div class="section_5">
          <span class="text_5">系列</span>
          <div>
            <!-- <span
                :class="{ 'active-tag': activeMajor === '全部类别' }"
                class="text_6"
                @click="selectMajor(data1, 1)"
                >全部</span
              > -->
          </div>
          <div class="box_2" style="overflow-y: scroll; white-space: nowrap">
            <span
              v-for="(item, index) in majorCategories"
              :key="index"
              class="text_6"
              :class="{
                'active-tag': activeMajor && activeMajor.codeNo === item.codeNo
              }"
              @click="selectMajor(item)"
            >
              {{ item.codeName }}
            </span>
          </div>
        </div>
        <div class="section_5">
          <span class="text_5">专业</span>
          <div>
            <!-- <span
                :class="{ 'active-tag': activeIndustry === '全部行业' }"
                class="text_6"
                @click="selectIndustry(data2, 2)"
                >全部</span
              > -->
          </div>
          <div class="box_2" style="overflow-y: scroll; white-space: nowrap">
            <span
              v-for="(item, index) in industries"
              :key="index"
              class="text_6"
              :class="{ 'active-tag': activeIndustry === item }"
              @click="selectIndustry(item)"
            >
              {{ item.codeName }}
            </span>
          </div>
        </div>
        <div class="section_5" v-if="fourList.length !== 0">
          <span class="text_5">类别</span>
          <div>
            <!-- <span
                :class="{ 'active-tag': activeIndustry === '全部行业' }"
                class="text_6"
                @click="selectIndustry(data2, 2)"
                >全部</span
              > -->
          </div>
          <div class="box_2" style="overflow-y: scroll; white-space: nowrap" v-if="fourList.length !== 0">
            <span
              v-for="(item, index) in fourList"
              :key="index"
              class="text_6"
              :class="{ 'active-tag': activeFour === item }"
              @click="selectFour(item)"
            >
              {{ item.codeName }}
            </span>
          </div>
        </div>
        <div class="text-wrapper_4" @click="open">
          <!-- <span class="text_14">{{
              isExpanded ? "点击收起" : "点击展开"
            }}</span> -->
          <span class="text_14">点击展开 </span>
        </div>
      </div>
      <div class="classification" v-if="!showOpen">
        <div class="section_5">
          <span class="text_5">分类</span>

          <div class="box_2">
            <!-- <span
                :class="{ 'active-tag': activeCategory === '全部' }"
                class="text_6"
                @click="selectCategory(all)"
                >全部</span
              > -->
            <span
              v-for="(item, index) in categories.professional"
              :key="index"
              class="text_6"
              :class="{ 'active-tag': activeCategory === item.codeName }"
              @click="selectCategory(item)"
            >
              {{ item.codeName }}
            </span>
          </div>
        </div>
        <div class="section_5">
          <span class="text_5">系列</span>

          <div class="box_2">
            <!-- <span
                :class="{ 'active-tag': activeMajor === '全部类别' }"
                class="text_6"
                @click="selectMajor(data1, 1)"
                >全部</span
              > -->
            <span
              v-for="(item, index) in majorCategories"
              :key="index"
              class="text_6"
              :class="{
                'active-tag': activeMajor && activeMajor.codeNo === item.codeNo
              }"
              @click="selectMajor(item)"
            >
              {{ item.codeName }}
            </span>
          </div>
        </div>
        <div class="section_5">
          <div class="text_5">专业</div>

          <div class="box_2" style="display: flex; flex-wrap: wrap; width: 120%">
            <!-- <span
                :class="{ 'active-tag': activeIndustry === '全部行业' }"
                class="text_6"
                @click="selectIndustry(data2, 2)"
                >全部</span
              > -->
            <span
              v-for="(item, index) in industries"
              :key="index"
              class="text_6"
              :class="{ 'active-tag': activeIndustry === item }"
              @click="selectIndustry(item)"
            >
              {{ item.codeName }}
            </span>
          </div>
        </div>

        <div class="section_5" v-if="fourList.length !== 0">
          <div class="text_5">类别</div>

          <div class="box_2" style="display: flex; flex-wrap: wrap; width: 120%">
            <!-- <span
                :class="{ 'active-tag': activeIndustry === '全部行业' }"
                class="text_6"
                @click="selectIndustry(data2, 2)"
                >全部</span
              > -->
            <span
              v-for="(item, index) in fourList"
              :key="index"
              class="text_6"
              :class="{ 'active-tag': activeFour === item }"
              @click="selectFour(item)"
            >
              {{ item.codeName }}
            </span>
          </div>
        </div>
        <div class="text-wrapper_4" @click="open">
          <!-- <span class="text_14">{{
              isExpanded ? "点击收起" : "点击展开"
            }}</span> -->
          <span class="text_14">点击收起 </span>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="group_2">
      <div class="li" v-for="course in courselist" :key="course.id" @click="handZjDetail(course)">
        <div class="left">
          <img :src="course.classImage" alt="安徽继续教育网" v-if="course.classImage !== null" />
          <img src="../assets/new/xiaoBg.png" alt="安徽继续教育网" v-else />
        </div>
        <div class="right">
          <div class="text_1">
            {{ course.className || '' }}
          </div>
          <div class="text_2">
            <span class="tearch1">{{ course.classCredithour || 0 }}学时</span>
            <!-- <span class="money">￥{{ course.classPrice || 0 }}</span> -->
          </div>
          <div class="tearch">
            <span class="money" v-if="course.isClassApply == '02'"
              ><span style="font-weight: 500; color: red; font-size: 12px">￥</span>{{ course.classPrice.toFixed(1) || 0 }}
            </span>
            <div class="money" v-if="course.isClassApply == '01' || course.isClassApply == null">
              <span style="font-weight: 500; color: red; font-size: 12px">￥</span>{{ course.creditPrice || 0 }}
              <span style="font-size: 12px; font-weight: 500; color: red">/学时</span>
            </div>
            <!-- 职业培训播放 -->
            <div class="btn_7" v-if="course.isClassApply == '02' && course.isBuy == '02' && course.isZYPX == '02'" @click="toWatch1">
              <img src="../assets/new/bofang.png" alt="" /><span>播放</span>
            </div>
            <!-- 专业课播放 -->
            <div
              class="btn_7"
              v-if="course.isClassApply == '02' && course.isBuy == '02' && course.isZYPX == '01'"
              @click="toWatch2(course)"
            >
              <img src="../assets/new/bofang.png" alt="" /><span>播放</span>
            </div>

            <div class="btn" v-if="course.classEnrolStatus == '02' && course.isClassApply == '01'">
              <span class="bofang" @click.stop="handleDetail(course)"> 试看</span>
              <span class="pay" @click.stop="handleorder(course)"> 购买</span>
              <!-- <span class="pay1" @click.stop="handleorder(course)" v-if="course.resChapterVo==null||course.resChapterVo==''">购买</span> -->
            </div>
            <div class="btn" v-if="course.isBuy == '01' && course.classEnrolStatus == '02' && course.isClassApply == '02'">
              <span class="bofang" @click.stop="handleDetail(course)"> 试看</span>
              <span class="pay" @click.stop="handleorder(course)"> 购买</span>
              <!-- <span class="pay1" @click.stop="handleorder(course)" v-if="course.resChapterVo==null||course.resChapterVo==''">购买</span> -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="loding" style="height: 118px; text-align: center; padding-top: 20px; font-size: 16px">
        {{ loding ? '加载中...' : '' }}
      </div>
      <div style="height: 118px" v-if="courselist.length == 0"></div>
      <!-- 加载更多 -->
      <div class="load-more" v-if="courselist.length > 0 && !isNoMoreData && !loding">
        <div @click="loadMore" style="color: #999">点击加载更多</div>
      </div>
      <div class="no-more" v-if="isNoMoreData">没有更多数据了</div>
    </div>
    <van-popup v-model="balanceShow" round>
      <div class="balanBox">
        <div class="b1">账户余额抵扣支付</div>

        <van-checkbox-group v-model="balanRadio" icon-size="16px" class="bn2" @change="onCheckboxChange">
          <van-cell-group class="bn2">
            <van-cell clickable @click="toggleCheck('1')" v-if="balance > 0">
              <div>
                <div class="b2">账户余额支付 ¥{{ Number(classPrice).toFixed(2) }}</div>
                <div class="b3">剩余{{ balanZkNum.toFixed(2) < 0 ? 0 : balanZkNum.toFixed(2) }}元</div>
              </div>
              <template #right-icon>
                <van-checkbox name="1" ref="checkboxes" />
              </template>
            </van-cell>
            <van-cell clickable @click="toggleCheck('2')" v-if="surplusIntegral > 0">
              <div>
                <div class="b2">账户积分抵扣 ¥{{ Math.min(surplusIntegral / 30, classPrice).toFixed(2) }}</div>
                <div class="b3" v-if="this.balanRadio[0] == '2'">
                  剩余积分抵扣金额{{ balanZkNum1.toFixed(2) < 0 ? 0 : balanZkNum1.toFixed(2) }}元
                </div>
                <div class="b3" v-else>剩余积分抵扣金额{{ (surplusIntegral / 30).toFixed(2) }}元</div>
              </div>
              <template #right-icon>
                <van-checkbox name="2" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>

        <div class="btnBox">
          <div class="btn" style="background: #e4e4e4; color: #666666" @click="balanceShow = false">取消</div>
          <div class="btn" @click="toOrder">立即购买</div>
        </div>
      </div>
    </van-popup>
    <!-- 底部导航 -->
    <bottomNav></bottomNav>

    <!-- <loading v-if="ajaxFalg" ></loading> -->
  </div>
</template>

<script>
import bottomNav from './component/tabBar.vue';
import loading from './component/loading.vue';
import { toClassCenter, toCode, toGeneratePxOrder, toTry } from '../api/chooseClass';
import { toGenerateOrder } from '../api/classDetail';
import { Dialog } from 'vant';

export default {
  data() {
    return {
      showOpen: 'true',
      all: {
        codeNo: '',
        codeName: '全部'
      },
      data1: '',
      data2: '',
      data3: '',
      activeCategory: '全部', // 当前选中的分类
      activeMajor: '全部系列', // 当前选中的类别
      activeIndustry: '全部行业', // 当前选中的行业
      activeFour: '', // 当前选中的专业
      pageNum: 1, // 当前页码
      className: '', // 班级名称
      pageSize: 5, // 每页多少条
      surplusIntegral: 0, //积分
      balanZkNum1: 0, //折扣后剩下的积分
      isFirstToPage: true, // 是否是刚进入页面
      codeNo: '', // 分类编号
      majorNo: '', // 类别编号
      courselist: [],
      getMajorData: {}, // 完整的分类、类别和行业数据
      categories: {
        professional: [] // 分类列表
      },
      majorCategories: [], // 类别
      industries: [], // 动态加载的行业
      maxVisibleTags: 4, // 最大显示标签数量
      isNoMoreData: false, // 是否没有更多数据
      isExpanded: false,
      isZypx: '', //是否是职业培训课程
      loding: true,
      typeIndex: '0702',
      ajaxFalg: false, //节流
      fourList: [], //职业培训的第四级分类
      balanceShow: false,
      balanRadio: [],
      balanZkNum: 0, //折扣后剩下的余额
      payFalg: false,
      balance: 0, //账户余额抵扣
      classPrice: '',
      classIds: '',
      itemRefs: {},
      jfPrice: '' //积分支付价格
    };
  },
  components: {
    bottomNav,
    loading
  },
  created() {
    this.typeIndex = this.$route.query.type;
    // this.setNavBottom();
    this.pageNum = 1;
    this.isNoMoreData = false;
    // 检查路由中是否有 classNo
    const classNoFromRoute = this.$route.query.classNo;
    if (classNoFromRoute) {
      this.codeNo = classNoFromRoute;
      this.setTypeByClassNo(classNoFromRoute);
    } else {
      this.getType();
    }
    window.scrollTo({
      top: 0
    });
  },
  watch: {
    $route: 'handleRoute'
  },
  methods: {
    //余额和积分单选
    toggleCheck(name) {
      if (this.balanRadio[0] === name) {
        this.balanRadio = [];
      } else {
        this.balanRadio = [name];
      }
      this.onCheckboxChange(this.balanRadio);
    },
    onCheckboxChange(value) {
      console.log('当前选中:', value);
    },
    handleRoute() {
      const classNo = this.$route.query.type;
      if (classNo) {
        const targetItem = this.findCategoryByCodeNo(classNo);
        console.log(targetItem, '999');

        if (targetItem) {
          this.activeCategory = targetItem.codeName;
          this.scrollToActiveItem();
        }
      }
    },
    findCategoryByCodeNo(codeNo) {
      var _this = this;
      return _this.categories.professional.find(item => item.codeNo === codeNo);
    },
    setItemRef(el, codeNo) {
      this.itemRefs[codeNo] = el;
    },
    scrollToActiveItem() {
      this.$nextTick(() => {
        const codeNo = this.$route.query.type;
        const itemEl = this.itemRefs[codeNo];
        //找到路由对应的位置并滑动居中
        const containerEl = this.$refs.scrollContainer;
        if (itemEl && containerEl) {
          const containerWidth = containerEl.clientWidth;
          const itemWidth = itemEl.offsetWidth;
          const itemLeft = itemEl.offsetLeft;
          // 让元素居中显示
          containerEl.scrollTo({
            // left: itemLeft - (containerWidth / 2 - itemWidth / 2),
            left: itemLeft - containerWidth / 2,

            behavior: 'smooth'
          });
        }
      });
    },
    selectCategory(item) {
      this.activeCategory = item.codeName;
      this.$router.push({
        path: '/course/list',
        query: { ...this.$route.query, classNo: item.codeNo }
      });
    },
    //根据路由id找到对应分类
    setTypeByClassNo(classNo) {
      var _this = this;
      var params = { parent: '07' }; // 默认大类为 07
      toCode(params).then(res => {
        const data = res.data.data; // 获取第一层分类数据
        _this.categories.professional = data.map(item => ({
          codeName: item.codeName,
          codeNo: item.codeNo
        }));
        _this.getMajorData = data;
        const defaultCategory = data.find(item => item.codeNo == _this.codeNo);
        if (defaultCategory) {
          _this.activeCategory = defaultCategory.codeName;
          const majorCategories = defaultCategory.codeList || [];
          _this.majorCategories = majorCategories;
          // 查找与路由参数 classNo 匹配的类别
          const targetMajor = majorCategories.find(major => major.codeNo === _this.codeNo);
          if (targetMajor) {
            _this.activeMajor = targetMajor;
            _this.industries = targetMajor.codeList || [];
            if (_this.industries.length > 0) {
              _this.selectIndustry(_this.industries[0]);
            }
          } else {
            if (_this.majorCategories.length > 0) {
              _this.selectMajor(_this.majorCategories[0]);
            }
          }
        }
        _this.getCourse1(classNo || '0701');
      });
    },
    //获取所有分类
    getType() {
      var _this = this;
      var params = { parent: '07' }; // 默认大类为 17
      toCode(params).then(res => {
        const data = res.data.data; // 获取第一层分类数据
        _this.categories.professional = data.map((item, idx) => ({
          codeName: item.codeName,
          codeNo: item.codeNo
        }));
        this.handleRoute();

        _this.getMajorData = data;
        if (_this.categories.professional.length > 0) {
          if (_this.typeIndex !== undefined) {
            _this.categories.professional.forEach((v, idx) => {
              if (v.codeNo == _this.typeIndex) {
                _this.selectCategory(_this.categories.professional[idx]);
              }
            });
          } else {
            _this.typeIndex = '0702';
            _this.categories.professional.forEach((v, idx) => {
              if (v.codeNo == _this.typeIndex) {
                _this.selectCategory(_this.categories.professional[idx]);
              }
            });
            // _this.selectCategory(_this.categories.professional[0]);
          }
        }
      });
    },
    //专业课去播放
    toWatch2() {
      this.$router.push({
        path: '/myClass',
        query: {
          name: 'a'
        }
      });
    },
    //职业培训播放
    toWatch1() {
      this.$router.push({
        path: '/myClass',
        query: {
          name: 'b'
        }
      });
    },
    //职业培训生成订单
    handleorder(course) {
      //02表示是职业培训课程
      if (course.isZYPX == '02') {
        const data = {
          classId: course.id,
          courseIds: '',
          derateType: '',
          equipment: '02'
        };
        toGenerateOrder(data).then(res => {
          if (res.data.data.result == 0) {
            //创建订单失败返回信息
            this.$utils.showToast(res.data.data.msg);
            return false;
          }
          if (res.data.data.result == 1) {
            //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
            let data = res.data.data.order;
            this.$router.push({
              path: '/payType',
              query: data
            });
          }
          //已有订单
          if (res.data.data.result == 3) {
            this.balanceShow = false;
            Dialog.confirm({
              title: '温馨提示',
              message: res.data.data.msg,
              confirmButtonColor: '#2A70F2'
            })
              .then(() => {
                this.$router.push('/myOrder');
              })
              .catch(() => {
                // this.$utils.showToast('用户点击了取消');
              });
            return false;
          }
        });
      } else {
        //非职业培训课程
        //非整体报名
        if (course.isClassApply == '01') {
          this.$router.push({
            path: '/classDetail',
            query: { classId: course.id }
          });
        } else {
          //整体报名
          //判断余额是否抵扣
          if (this.balance !== 0 || this.surplusIntegral != 0) {
            this.classPrice = course.classPrice;
            this.balanceShow = true;
            this.classIds = course.id;
            this.balanZkNum = this.balance - course.classPrice;
            this.balanZkNum1 = (this.surplusIntegral / 30).toFixed(2) - course.classPrice;
          } else {
            this.classIds = course.id;

            this.toOrder();
          }
        }
      }
    },
    //购买生成订单
    toOrder() {
      if (this.payFalg) {
        this.$utils.showToast('点击过快，请稍后再试！');
        return false;
      }
      let data = {
        classId: this.classIds,
        derateType: this.balanRadio[0] == '1' ? '01' : this.balanRadio[0] == '2' ? '02' : '03', //判断是否勾选了抵扣
        courseIds: '',
        equipment: '02'
      };
      this.payFalg = true;
      setTimeout(() => {
        this.payFalg = false;
      }, 5000);
      toGenerateOrder(data).then(res => {
        this.payFalg = false;
        if (res.data.data.result == 0) {
          //创建订单失败返回信息
          this.$utils.showToast(res.data.data.msg);
          this.balanceShow = false;
          return false;
        }
        if (res.data.data.result == 1) {
          //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
          let data = res.data.data.order;
          this.$router.push({
            path: '/payType',
            query: data
          });
        }
        //余额大于金额，直接购买成功
        if (res.data.data.result == 2) {
          let data = res.data.data.order;
          this.$router.push({
            path: '/paySuccess',
            query: data
          });
        }
        //已有订单
        if (res.data.data.result == 3) {
          this.balanceShow = false;
          Dialog.confirm({
            title: '温馨提示',
            message: res.data.data.msg,
            confirmButtonColor: '#2A70F2'
          })
            .then(() => {
              this.$router.push('/myOrder');
            })
            .catch(() => {
              // this.$utils.showToast('用户点击了取消');
            });
          return false;
        }
      });
    },
    selectCategory(category) {
      if (this.ajaxFalg) {
        return false;
      }
      this.activeCategory = category.codeName;
      this.majorCategories = []; // 清空类别
      this.industries = []; // 清空行业
      this.courselist = []; // 清空课程列表
      this.activeFour = [];
      this.fourList = [];
      this.activeMajor = '';

      this.pageNum = 1;
      this.isNoMoreData = false;
      this.getCourse1(category.codeNo);
      if (category.codeNo === '0701') {
        this.activeCategory = category.codeName;
      }

      const selectedCategoryData = this.getMajorData.find(item => item.codeName === category.codeName);
      this.majorCategories = selectedCategoryData.codeList;

      // if (
      //   selectedCategoryData &&
      //   selectedCategoryData.codeList.length > 0
      // ) {
      //   this.majorCategories = selectedCategoryData.codeList;
      //   if (this.majorCategories.length > 0) {
      //     this.selectMajor(this.majorCategories[0]);
      //   }
      // } else if (selectedCategoryData.codeList.length < 1) {
      //   this.getCourse1(category.codeNo);
      // }
    },
    selectMajor(major) {
      if (this.ajaxFalg) {
        return false;
      }
      this.activeMajor = major;
      this.industries = []; // 清空行业
      this.courselist = []; // 清空课程列表
      this.activeFour = [];
      this.fourList = [];
      this.activeIndustry = '';

      this.pageNum = 1;
      this.isNoMoreData = false;
      this.getCourse1(major.codeNo);

      if (major && major.codeList.length > 0) {
        this.industries = major.codeList;
        // if (this.industries.length > 0) {
        // this.getCourse1(major.codeNo);

        // this.selectIndustry(this.industries[0]);
        // }
      } else if (major.codeList.length < 1) {
        // this.getCourse1(major.codeNo);
      } else {
        this.industries = [];
      }
    },
    selectIndustry(industry) {
      console.log(industry, '9999');
      if (this.ajaxFalg) {
        return false;
      }
      this.activeIndustry = industry; // 更新选中的行业
      this.courselist = []; // 清空课程列表
      this.activeFour = [];
      this.pageNum = 1; // 重置页码
      this.isNoMoreData = false; // 重置是否有更多数据状态
      this.getCourse1(industry.codeNo);

      if (industry && industry.codeList != null && industry.codeList.length > 0) {
        this.fourList = industry.codeList;
        if (this.fourList.length > 0) {
          // this.getCourse1(industry.codeNo);
          // this.selectFour(this.fourList[0]);
        }
      } else if (industry.codeList == null || industry.codeList.length < 1) {
        this.fourList = [];
        // this.getCourse1(industry.codeNo);
      } else {
        this.fourList = [];
      }
    },
   //点击类别
    selectFour(four) {
      if (this.ajaxFalg) {
        return false;
      }
      this.activeFour = four; // 更新选中的类别
      this.courselist = []; // 清空课程列表
      this.pageNum = 1; // 重置页码
      this.isNoMoreData = false; // 重置是否有更多数据状态
      this.getCourse1(four.codeNo);
    },
    getCourse1(codeNo) {
      // if (this.ajaxFalg) {
      //   return false;
      // }
      this.ajaxFalg = true;
      var _this = this;
      var params = {
        codeNo: codeNo,
        className: _this.className,
        pageNum: _this.pageNum, // 当前页码
        pageSize: _this.pageSize, // 每页条数
        token: localStorage.getItem('token')
      };
      this.data3 = codeNo;
      _this.loding = true;
      toClassCenter(params)
        .then(res => {
          if (res.data.aClass.rows) {
            if (_this.courselist.length == 0) {
              _this.courselist = res.data.aClass.rows;
              _this.balance = res.data.balance;
              _this.surplusIntegral = res.data.surplusIntegral;

              console.log(_this.balance, 'ww');
            } else {
              _this.courselist = [..._this.courselist, ...res.data.aClass.rows];
            }
            _this.isNoMoreData = _this.pageNum * _this.pageSize > res.data.aClass.total;
            _this.loding = false;
          } else {
            _this.loding = false;
            _this.isNoMoreData = true;
          }
          _this.ajaxFalg = false;
        })
        .catch(error => {
          console.error('获取课程数据失败:', error);
          _this.ajaxFalg = false;
        });
    },
    open() {
      this.showOpen = !this.showOpen;
      this.isExpanded = !this.isExpanded; // 切换展开/收起状态
    },
    loadMore() {
      if (!this.isNoMoreData) {
        this.pageNum++;
        // const currentCodeNo = this.activeIndustry
        //   ? this.activeIndustry.codeNo
        //   : this.activeMajor
        //   ? this.activeMajor.codeNo
        //   : this.codeNo || "";
        const currentCodeNo = this.data3;
        this.getCourse1(currentCodeNo);
      }
    },
    handZjDetail(course) {
      console.log(course);

      //isZYPX   02 是职业培训   01 不是
      if (course.isZYPX == '01') {
        //购买了直接跳学习页面
        if (course.isClassApply == '02' && course.isBuy == '02') {
          this.$router.push({
            path: '/myClass',
            query: {
              name: 'a'
            }
          });
        } else {
          this.$router.push({
            path: '/classDetail',
            query: { classId: course.id }
          });
        }
      } else {
        if (course.isClassApply == '02' && course.isBuy == '02') {
          this.$router.push({
            path: '/myClass',
            query: {
              name: 'b'
            }
          });
        } else {
          this.$router.push({
            path: '/zyDetail',
            query: { classNo: course.id }
          });
        }
      }
    },
    handleDetail(course) {
      console.log(course, '000');
      toTry({ classId: course.id }).then(res => {
        if (res.data.code == 200) {
          this.$router.push({
            path: '/tryPlaying',
            query: { id: res.data.data.cwId, name: res.data.data.chapterTitle, isZYPX: course.isZYPX }
          });
        } else if (res.data.code == 500) {
          this.$utils.showToast('该课程暂不支持试看');
        }
      });
    },
    //跳到搜索页
    handleToSelect() {
      this.$router.push({
        path: '/select'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.box_2 {
  width: 291px;
}

.box_2::-webkit-scrollbar {
  display: none;
}

.box_3::-webkit-scrollbar {
  display: none;
}

.box_2 .text_6 {
  display: inline-block;
  margin-bottom: 5px;
}

.box_3 .text_6 {
  display: inline-block;
  margin-bottom: 5px;
}

/* 展开状态的样式 */
.expanded {
  height: auto !important;
  /* white-space: normal; */
  overflow: visible !important;
  text-overflow: none !important;
  white-space: pre-line !important;
}

.text-wrapper_4 {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  /* 可选：增加间距 */
}

.load-more {
  text-align: center;
  margin-top: 20px;
}

.no-more {
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-top: 20px;
}

.title {
  height: 53px;
  width: 100%;
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #333333;
  line-height: 53px;
  background-color: #fff;
}

.page {
  width: 100%;
  height: 100vh;
  background-color: #f2f7fa;
  overflow-y: scroll;
  overflow-x: hidden;
}

.search {
  position: relative;
  background-color: #fff;
  width: 100%;
  height: 40px;
  // margin-left: 15px;
}

.search img {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 53%;
  left: 22px;
  transform: translateY(-50%);
}

.search-input {
  border: 0;
  width: 100%;
  height: 42px;
  background: #f6f8fa;
  border-radius: 8px 8px 8px 8px;
  padding-left: 40px;
  font-size: 14px;
  color: #999;
}

.group_1 {
  display: block;
  background-color: #fff;
  padding: 0 15px;
}

.search-input::placeholder {
  color: #999;
}

.group_2 {
  min-height: 70vh;
  background: #fff;
  height: auto;
  margin-top: 10px;
  padding-bottom: 120px;
}

.li {
  /* margin-bottom: 10px; */
  width: 100%;
  height: 118px;
  background: #ffffff;
  padding: 24px 15px 0 15px;
  display: flex;
}

.li .left {
  width: 110px;
  margin-right: 10px;
  height: 88px;
}

.li .left img {
  width: 110px;
  height: 88px;
  border-radius: 8px;
}

.text_1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  display: -webkit-box;
  /* 使用弹性盒模型 */
  -webkit-box-orient: vertical;
  /* 垂直排列子元素 */
  -webkit-line-clamp: 1;
  /* 限制显示的行数为2行 */
  overflow: hidden;
  line-height: 18px;
  text-align: left;
}

.tearch {
  height: 32px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tearch1 {
  font-family: PingFang SC, PingFang SC;
  font-size: 13px;
  color: #999999;
}

.money {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #ff2d31;
}

.right {
  width: 225px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.text_2 {
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
}

.classification {
  display: block;
  padding: 20px 0px 0 15px;
}

.text_5 {
  width: 40px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #1e325f;
  line-height: 19px;
  margin-right: 16px;
  text-align: left;
  flex-shrink: 0;
  /* 禁止收缩 */
  height: 28px !important;
  line-height: 28px;
}

.text_6 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #667280;
  margin-right: 18px;
  cursor: pointer;
  height: 28px !important;
  padding: 0px 8px;
  line-height: 28px;
}

.section_5 {
  margin-bottom: 16px;
  display: flex;
}

.text-wrapper_4 {
  width: 100%;
  text-align: center;
}

.text_14 {
  display: inline-block;
  width: 110px;
  height: 28px;
  background-image: url('../assets/new/zk.png');
  background-size: cover;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #2a70f2;
  line-height: 28px;
  text-align: center;
}

.box_3 {
  width: 260px;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
  line-height: 28px;
}

.active-tag {
  border-radius: 30px 30px 30px 30px;
  border: 1px solid #2a70f2;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2a70f2;
  padding: 0px 8px;
}
.pay {
  width: 50px;
  display: inline-block;

  height: 32px;
  background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
  border-radius: 0px 27px 27px 0px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 32px;
}
.pay1 {
  width: 100px;
  display: inline-block;

  height: 32px;
  background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
  border-radius: 27px 27px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 32px;
}
.bofang {
  display: inline-block;
  width: 50px;
  height: 32px;
  background: #f3f3f5;
  border-radius: 27px 0px 0px 27px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #2a70f2;
  text-align: center;
  line-height: 32px;

  img {
    width: 16px;
    height: 16px;
  }
}
.btn_7 {
  width: 74px;
  height: 32px;
  background: #f3f3f5;
  border-radius: 27px 27px 27px 27px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #2a70f2;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
}
.balanBox {
  width: 300px;
  height: aoto;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 22px 20px;
  .b1 {
    color: #333333;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
  }
  .bn2 {
    margin-top: 20px;
    width: 100% !important;
    background: #f6f8fa !important;
    border-radius: 8px 8px 8px 8px;
    .b2 {
      color: #333333;
      font-size: 14px;
    }
    .b3 {
      color: #999999;
      font-size: 12px;
    }
  }

  .btnBox {
    display: flex;
    justify-content: space-between;
    .btn {
      margin-top: 20px;
      width: 117px;
      height: 48px;
      background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
      border-radius: 8px 8px 8px 8px;
      text-align: center;
      line-height: 48px;
      font-size: 15px;
      color: #fff;
    }
  }
}
</style>
